import { getAgentById } from '../../apiClient';
import { useQuery } from '@tanstack/react-query';

const useGetAgentByIdQuery = (agentId, enabled = true) =>
    useQuery({
        queryKey: ['agent', agentId],
        queryFn: async () => await getAgentById(agentId),
        throwOnError: (error) => false,
        refetchOnMount: false,
        retryOnMount: false,
        enabled: enabled,
    });
export default useGetAgentByIdQuery;
